export const requiredMessage = 'Required';
export const alphaMessage = 'Only alpha character';
export const emailMessage = 'Invalid email address';
export const minLengthMessage = min => `Must be ${min} or more characters`;
export const maxLengthMessage = max => `Must be less than ${max} characters`;

export const required = value => {
  return value && value.length !== 0 ? undefined : requiredMessage;
};

export const alpha = value => {
  return value && /[^a-zA-Z]/i.test(value) ? alphaMessage : undefined;
};

export const email = value => {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? emailMessage
    : undefined;
};

export const minLength = min => value => {
  return value && value.length < min ? minLengthMessage(min) : undefined;
};

export const maxLength = max => value => {
  return value && value.length > max ? maxLengthMessage(max) : undefined;
};
